import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: 'https://vxmdi44.hfd.gov.iq/hpi/',
  //baseURL: 'http://localhost/hpi/',
})


const token = localStorage.getItem('token')
if (token) {
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export default {
  install(app) {
    app.config.globalProperties.$axios = axiosInstance
    window.axios = axiosInstance
  }
}

export { axiosInstance }
